import api from "./client"; // у тебя уже есть client.js

export const getUnreadCount = () =>
  api.get("/api/notifications/unread_count/");

export const getNotifications = () =>
  api.get("/api/notifications/");

export const markAsRead = (id) =>
  api.post(`/api/notifications/${id}/mark_as_read/`);

export const markAllRead = () =>
  api.post("/api/notifications/mark_all_read/");
